import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { httpClient } from '@/api/http-client'
import { Document, DocumentStatus, EntityType } from '@/types'

type ReadDocumentsParams = {
  entity_key: string
  entity_type: EntityType
  document_request_key?: string
  status?: DocumentStatus
}

type ReadDocumentResponse = Array<Document>

export async function readDocuments({
  entity_key,
  entity_type,
  document_request_key,
  status,
}: ReadDocumentsParams) {
  const response = await httpClient(
    'accounting-dealer',
  ).get<ReadDocumentResponse>('/v3/file/document', {
    params: { entity_key, entity_type, document_request_key, status },
  })

  return response.data
}

export function useReadDocuments(
  {
    entity_key,
    entity_type,
    document_request_key,
    status,
  }: ReadDocumentsParams,
  options?: Partial<UseQueryOptions<ReadDocumentResponse>>,
) {
  return useQuery({
    queryKey: [
      'documents',
      entity_key,
      entity_type,
      document_request_key,
      status,
    ],
    queryFn: () =>
      readDocuments({ entity_key, entity_type, document_request_key, status }),
    ...options,
  })
}
